import { createAction, props } from '@ngrx/store';
import { IEmployeeDetailRequest, IEmployeeDetailResponse } from '../models/employee-detail.model';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { IEmployeeGovtIdDetailsPutRequest, IEmployeeGovtIdDetailsPutResponse } from '../models/employee-govt-id-details.model';

export const loadEmployeeDetailsRequest = createAction('[EmployeeDetail] Load EmployeeDetails', props<{ request: any }>());

export const loadEmployeeDetailsSuccess = createAction(
  '[EmployeeDetail] Load EmployeeDetails Success',
  props<{ response: IEmployeeDetailResponse }>()
);

export const loadEmployeeDetailsFailure = createAction(
  '[EmployeeDetail] Load EmployeeDetails Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearEmployeeDetails = createAction('[EmployeeDetail] Clear EmployeeDetails');

export const putEmployeeGovtIdDetailsRequest = createAction(
  '[EmployeeDetail] Put EmployeeGovtIdDetails Request',
  props<{ customerId: string; userIdentityId: string; request: IEmployeeGovtIdDetailsPutRequest }>()
);

export const putEmployeeGovtIdDetailsSuccess = createAction(
  '[EmployeeDetail] Put EmployeeGovtIdDetails Success',
  props<{ response: IEmployeeGovtIdDetailsPutResponse[] }>()
);

export const putEmployeeGovtIdDetailsFailure = createAction(
  '[EmployeeDetail] Put EmployeeGovtIdDetails Failure',
  props<{ error: any }>()
);
